export const translations = {
    selectAll: "Seleziona Tutti",
    selectSomeItems: "Seleziona",
    search: 'Cerca',
    allItemsAreSelected: "Hai selezionato tutti gli elementi"
}